import styled from "styled-components";

export const SpacerContainer = styled.div`
  margin-top: 30px;
`;
